import apiClient from "./client";
import type { GetMailsParams, MailsListResponse } from "../types/mail";

export const getMails = async (
  params: GetMailsParams
): Promise<MailsListResponse> => {
  const { data } = await apiClient.get<MailsListResponse>("/mails", {
    params,
  });
  return data;
};
